export default "__VITE_ASSET__BMsBsrrY__"